<template>
      <v-main>
        <v-container
          class="fill-height"
          fluid
        >
        <v-row>
          <v-col sm="4">
              <v-img :contain="true" class="d-none d-sm-flex" max-height="200" src="ncmh_logo_compressed.png"></v-img>
          </v-col>
          <v-col sm="4">
              <v-img :contain="true" max-height="300" src="crisis-logo.jpeg"></v-img>
          </v-col>
          <v-col sm="4">
              <v-img :contain="true" class="d-none d-sm-flex" max-height="200" src="PGCA.png"></v-img>
          </v-col>

        </v-row>
          <v-row
            align="center"
            justify="center"
          >
            <v-col
              cols="12"
              sm="8"
              md="4"
            >
              <v-card class="elevation-12">
                <v-toolbar
                  color="teal darken-4"
                  dark
                  flat
                >
                  <v-toolbar-title>Login form</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        color="yellow accent-4"
                        light
                        to='/landing'
                      >
                        <span>
                        <v-icon>mdi-home-variant</v-icon>
                        Home
                        </span>

                      </v-btn>
                    </template>
                    <span>Go Back to home page</span>
                  </v-tooltip>
                </v-toolbar>
                <v-card-text>
                  <v-form>
                    <v-text-field
                      label="Login"
                      name="login"
                      v-model="username"
                      prepend-icon="mdi-account"
                      type="text"
                    ></v-text-field>
  
                    <v-text-field
                      id="password"
                      label="Password"
                      name="password"
                      v-model="password"
                      prepend-icon="mdi-lock"
                      type="password"
                      v-on:keydown.enter="login"
                    ></v-text-field>
                    <router-link to='/forgot_password'><p class="subtitle-2 text-center">Forgot Password?</p></router-link>
                  </v-form>
                  <p class="subtitle error-msg">{{ errorMsg }}</p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-3" dark @click="login">
                    <span>Login
                    <v-icon>mdi-login</v-icon>
                    </span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-main>  
</template>

<script>
import { EventBus } from '../utils'
export default {
    name: "login",
    data() {
        return {
            username: "",
            password: "",
            errorMsg: ""
        }
    },
    methods: {
        login: function() {
            this.$store.dispatch('login', { username: this.username, password: this.password })
                .then(() => this.$router.push('/')).catch(()=>{
                  this.errorMsg = "Invalid user name or password"
                })
        }
    },
    mounted() {
   
    },
    beforeDestroy() {
        EventBus.$off('failedAuthentication')
    }
}
</script>

<style scoped>
.error-msg {
  color: red;
  font-weight: bold;
}
</style>